<template>
    <div class="login-bg">
        <div class="login-layout">
            <div class="login-card">
                <div class="login-title">意霆数字化医疗设备管理平台</div>
                <div class="login-subtitle">智能物联网管理系统</div>
                <el-form :model="loginForm" :rules="rules" ref="ruleForm" label-position="top" class="login-form">
                    <el-form-item label="账号" prop="userName">
                        <el-input
                            class="custom-input"
                            prefix-icon="el-icon-user"
                            v-model="loginForm.userName"
                            autocomplete="username"
                            placeholder="请输入账号"
                        />
                    </el-form-item>
                    <el-form-item label="密码" prop="checkPass">
                        <el-input
                            class="custom-input"
                            :type="passwordType"
                            prefix-icon="el-icon-lock"
                            v-model="loginForm.checkPass"
                            autocomplete="current-password"
                            placeholder="请输入密码"
                            @keyup.enter.native="handleEnter"
                        >
                            <i
                                slot="suffix"
                                class="password-eye el-icon-view"
                                :class="{ 'password-eye--active': isPasswordVisible }"
                                @click="togglePasswordVisible"
                            ></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="needCaptcha" label="验证码" prop="captchaCode">
                        <div class="captcha-row">
                            <el-input
                                class="custom-input captcha-input"
                                prefix-icon="el-icon-key"
                                v-model="loginForm.captchaCode"
                                placeholder="请输入验证码"
                                maxlength="6"
                                @keyup.enter.native="handleEnter"
                            />
                            <img
                                v-if="captchaImage"
                                class="captcha-image"
                                :src="captchaImage"
                                title="点击刷新"
                                @click="fetchCaptcha"
                            />
                            <div v-else class="captcha-placeholder" @click="fetchCaptcha">点击获取</div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="loginForm.remember" class="remember-checkbox">记住密码</el-checkbox>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="login-btn" type="primary" :loading="logining" round block @click.native.prevent="handleSubmit">
                            登录
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="login-footer">
            <p>Copyright © 2024 上海意霆环保科技有限公司 All Rights Reserved.</p>
            <p class="login-footer__icp">
                <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">沪ICP备2026022188号</a>
                <span class="login-footer__sep">|</span>
                <a class="login-footer__police" href="https://beian.mps.gov.cn/#/query/webSearch?code=31011702891894" target="_blank" rel="noopener noreferrer">
                    <img class="login-footer__badge" :src="require('@/assets/imgs/beian_police.png')" alt="公网安备" />沪公网安备31011702891894号
                </a>
            </p>
        </div>
    </div>
</template>

<script>
import { loginFn, getCaptchaFn } from '@/api/system'
import { setAuth } from '@/utils/auth.js'

export default {
    data() {
        return {
            isPasswordVisible: false,
            loginForm: {
                userName: '',
                checkPass: '',
                captchaCode: '',
                remember: false,
            },
            logining: false,
            // need_captcha 由后端在登录失败响应里指明（连续失败到阈值后强制）
            needCaptcha: false,
            captchaId: '',
            captchaImage: '',
            rules: {
                userName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                captchaCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
            },
        }
    },
    computed: {
        passwordType() {
            return this.isPasswordVisible ? 'text' : 'password'
        },
    },
    created() {
        const savedUser = localStorage.getItem('rememberUser')
        if (savedUser) {
            const { userName, checkPass } = JSON.parse(savedUser)
            this.loginForm.userName = userName
            this.loginForm.checkPass = checkPass
            this.loginForm.remember = true
        }
    },
    methods: {
        handleEnter() {
            this.handleSubmit()
        },
        togglePasswordVisible() {
            this.isPasswordVisible = !this.isPasswordVisible
        },
        async fetchCaptcha() {
            try {
                const res = await getCaptchaFn()
                const payload = (res && res.data && res.data.data) || (res && res.data) || {}
                this.captchaId = payload.captcha_id || ''
                this.captchaImage = payload.captcha_image || ''
                this.loginForm.captchaCode = ''
            } catch (e) {
                this.$message({ message: '验证码获取失败，请重试', type: 'error' })
            }
        },
        handleSubmit() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) return
                this.logining = true
                const loginParams = {
                    username: this.loginForm.userName,
                    password: this.loginForm.checkPass,
                    client_type: 'web',
                    captcha_id: this.needCaptcha ? this.captchaId : '',
                    captcha_code: this.needCaptcha ? this.loginForm.captchaCode : '',
                }
                loginFn(loginParams).then(
                    (res) => {
                        this.logining = false
                        const data = res && res.data
                        if (this.loginForm.remember) {
                            localStorage.setItem('rememberUser', JSON.stringify({
                                userName: this.loginForm.userName,
                                checkPass: this.loginForm.checkPass,
                            }))
                        } else {
                            localStorage.removeItem('rememberUser')
                        }
                        this.$message({ message: '登录成功！', type: 'success', showClose: true })
                        const payload = (data && data.data) || data || {}
                        setAuth(payload, this.loginForm.userName)
                        this.$store.dispatch('permission/setFromLogin', {
                            pageKeys: payload.page_keys || [],
                            actionKeys: payload.action_keys || [],
                        })
                        const redirect = this.$route.query.redirect
                        this.$router.replace(redirect || '/platOverview')
                    },
                    (err) => {
                        this.logining = false
                        // axios 在 HTTP 非 2xx 时进 reject；后端用 401/429 + {code,msg,data}
                        const body = (err && err.response && err.response.data) || {}
                        const extra = body.data || {}
                        // 后端在失败响应 data.need_captcha 标记是否需要验证码
                        if (extra.need_captcha) {
                            this.needCaptcha = true
                            this.fetchCaptcha()
                        }
                        const msg = body.msg || body.message || '登录失败，请重试！'
                        this.$message({ message: msg, type: 'error', showClose: true })
                    }
                )
            })
        },
    },
}
</script>

<style lang="less" scoped>
@import '~@/styles/tokens.less';

.login-bg {
    min-height: 100vh;
    width: 100vw;
    background: url('~@/assets/imgs/loginPage/login_bg.png') no-repeat center center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    overflow: hidden;
}

.login-layout {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 120px;
    position: relative;
    z-index: 1;

    @media (max-width: 768px) {
        padding: 0 @spacing-lg;
        justify-content: center;
    }
}

.login-card {
    flex: none;
    width: 420px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 24px;
    box-shadow:
        0 20px 50px rgba(0, 0, 0, 0.3),
        0 0 0 1px rgba(255, 255, 255, 0.1);
    padding: 48px 40px;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);
    }
}

.login-title {
    font-size: 28px;
    font-weight: @font-weight-bold;
    color: @text-main;
    margin-bottom: @spacing-sm;
    text-align: center;
    letter-spacing: 0.5px;
}

.login-subtitle {
    font-size: @font-size-md;
    color: @color-text-secondary;
    text-align: center;
    margin-bottom: @spacing-xl;
}

.login-form {
    width: 100%;
}

.custom-input {
    width: 100%;
    margin-bottom: @spacing-sm;

    /deep/ .el-input__inner {
        height: 48px;
        line-height: 48px;
        font-size: 15px;
        color: @text-main;
        background: @color-bg-page;
        border: 1px solid transparent;
        border-radius: @radius-lg;
        transition: all 0.3s ease;
        padding-left: 44px;

        &:hover {
            background: @color-bg-card;
            border-color: @color-border;
        }

        &:focus {
            background: @color-bg-card;
            border-color: @color-primary;
            box-shadow: 0 0 0 3px fade(@color-primary, 10%);
        }

        &::placeholder {
            color: @text-placeholder;
        }
    }

    /deep/ .el-input__prefix {
        left: @spacing-sm;
        display: flex;
        align-items: center;

        i {
            font-size: 18px;
            color: @color-text-secondary;
            transition: all 0.3s ease;
        }
    }

    /deep/ .el-input__inner:focus + .el-input__prefix i {
        color: @color-primary;
    }
}

.login-btn {
    width: 100%;
    height: 48px;
    font-size: @font-size-lg;
    font-weight: @font-weight-bold;
    border: none;
    border-radius: @radius-lg;
    background: linear-gradient(135deg, @color-primary 0%, @primary-active 100%);
    color: #fff;
    box-shadow: 0 4px 12px fade(@color-primary, 30%);
    transition: all 0.3s ease;
    margin-top: @spacing-lg;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px fade(@color-primary, 40%);
        background: linear-gradient(135deg, lighten(@color-primary, 5%) 0%, @color-primary 100%);
    }

    &:active {
        transform: translateY(0);
    }
}

.captcha-row {
    display: flex;
    align-items: center;
    gap: @spacing-sm;

    .captcha-input {
        flex: 1;
        margin-bottom: 0;
    }

    .captcha-image,
    .captcha-placeholder {
        flex: none;
        width: 120px;
        height: 48px;
        border-radius: @radius-lg;
        cursor: pointer;
        user-select: none;
        background: @color-bg-page;
        border: 1px solid @color-border;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-text-secondary;
        font-size: @font-size-md;
        transition: border-color 0.2s ease;

        &:hover {
            border-color: @color-primary;
        }
    }

    .captcha-image {
        object-fit: contain;
    }
}

.remember-checkbox {
    margin-bottom: 0;

    /deep/ .el-checkbox__label {
        font-size: @font-size-md;
        color: @color-text-regular;
    }

    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: @color-primary;
        border-color: @color-primary;
    }

    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: @color-primary;
    }
}

.password-eye {
    font-size: 18px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    height: 100%;
    padding-right: 10px;
    color: @text-placeholder;
    opacity: 0.5;

    &--active {
        color: @color-primary;
        opacity: 1;
    }

    &:hover {
        color: @color-primary;
    }
}

.login-footer {
    position: absolute;
    bottom: @spacing-lg;
    width: 100%;
    text-align: center;
    z-index: 10;

    p {
        display: block;
        width: fit-content;
        margin: 0 auto;
        padding: 6px 18px;
        // 半透白磨砂胶囊：浅色背景下深字可读，照片背景下也能稳定显示
        background: rgba(255, 255, 255, 0.55);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        border: 1px solid rgba(255, 255, 255, 0.4);
        border-radius: 999px;
        color: rgba(15, 23, 42, 0.7);
        font-size: 12px;
        letter-spacing: 0.5px;
        font-weight: 400;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
    }

    p + p {
        margin-top: @spacing-sm;
    }

    a {
        color: inherit;
        text-decoration: none;

        &:hover {
            color: @color-primary;
        }
    }

    .login-footer__sep {
        margin: 0 8px;
        color: rgba(15, 23, 42, 0.35);
    }

    .login-footer__police {
        display: inline-flex;
        align-items: center;
        vertical-align: middle;
    }

    .login-footer__badge {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }
}
</style>

<style>
/* autofill 样式：scoped 里选不中 UA 伪类，必须放 global 块 */
input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #f8fafc inset !important;
    -webkit-text-fill-color: #1e293b !important;
    transition: background-color 5000s ease-in-out 0s;
}
</style>
